{
  "version": 1,
  "asset_id": "496b10ee-d96e-4bb7-9f40-2065f4b829d9",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/496b10ee-d96e-4bb7-9f40-2065f4b829d9/wordmark-400.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/496b10ee-d96e-4bb7-9f40-2065f4b829d9/wordmark-400.png",
  "original_filename": "wordmark-400.png",
  "size": 23320,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:19:08Z"
}
